module.exports = __webpack_public_path__ + "img/top3.88240e85.png";